import TurboCacheAware from "./turbo_cache_aware"

// Wraps the tagsManager jQuery plugin used on customer_orders/_form's tag
// picker: the "input" target is the free-text tag field the plugin turns
// into chips, "display" is the container it renders those chips into, and
// each "Available tag" button pushes its value into the plugin via addTag.
//
// Extends TurboCacheAware (see that file) -- the plugin has no destroy()
// of its own (app/javascript/vendor/tagmanager.js), and guards against
// double-init via `$self.data('tagManager')`, jQuery's own per-element data
// cache. If that guard is still set when Turbo restores a cached page
// snapshot, a later connect() silently no-ops (the plugin's own init just
// returns early) instead of re-rendering the prefilled chips. destroy()
// below manually reverses everything init() did so reconnecting is a clean
// re-init, not a resume of stale state.
export default class extends TurboCacheAware {
  static targets = ["input", "display"]
  static values = { prefilled: Array }

  connect() {
    $(this.inputTarget).tagsManager({
      prefilled: this.prefilledValue,
      tagsContainer: this.displayTarget,
    })

    this.cleanupOnCache(() => this.destroy())
  }

  addTag(event) {
    $(this.inputTarget).tagsManager("pushTag", event.currentTarget.value)
  }

  destroy() {
    const $input = $(this.inputTarget)
    const hiddenTagList = $input.data("lhiddenTagList")

    $(this.displayTarget).empty()
    if (hiddenTagList) $(hiddenTagList).remove()

    // Clears the tagManager/opts/tlis/tlid instance data the plugin keyed
    // to this element (including the double-init guard) and the keyup/
    // keydown/keypress/change handlers it bound in the same init() call.
    $input.removeData().off().val("")
  }
}
